// lib/supabaseClient.ts

import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://nlpjnsqwqafakrqnnxmq.supabase.co"; // Supabase 프로젝트 URL
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5scGpuc3F3cWFmYWtycW5ueG1xIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjE4MTM2NjEsImV4cCI6MjAzNzM4OTY2MX0.uK-4bFGbhu8xzGtTe4qzqTh2sNxGhuAoxLN1n2IgrwI"; // Supabase 공개 API 키
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
